module.exports = __webpack_public_path__ + "assets/site.2cd5cdce.svg";